const formattedData = (input: Date | string, fullFormat: boolean = false): string => {
  try {
    let dateObj: Date;
    if (typeof input === 'string') {
      dateObj = new Date(input);
    } else if (input instanceof Date) {
      dateObj = input;
    } else {
      throw new Error('Input must be a Date object or date string');
    }
    if (Number.isNaN(dateObj.getTime())) {
      throw new Error('Invalid date provided');
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    if (fullFormat) {
      return `${day}.${month}.${year}`;
    }

    return `${day}/${month}/${year}`;
  } catch (error) {
    return '';
  }
};

export default formattedData;

export const getTextDate = (date: Date | string): string => {
  try {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  } catch (error) {
    return '';
  }
};
